import {
  INIT_KIOSK,
  SETUP_DIRECT_MESSAGE_LINK,
  SET_MESSAGE,
  SET_REDIRECT,
  SET_CONNECTION_STATUS,
  SET_CHINESE_STATUS,
} from './useKioskReducerActions'
import { setSessionStorageItem } from '../../../../shared/helpers/sessionStorage'

const kioskInitialState = {
  message: null,
  video: null,
  color: null,
  redirect: null,
  unauthRedirect: null,
  undockRedirect: null,
  kioskQueryParams: null,
  isChinese: null,
  kioskId: null,
  tabletId: null,
  socketURL: '',
  directMessageTargetDeviceId: null,
  socket: { onopen: () => {}, onclose: () => {}, onmessage: () => {}, onerror: () => {} },
}

const kioskReducer = (state, action) => {
  const change = { ...state }

  switch (action.type) {
    case INIT_KIOSK: {
      change.video = action.data.video
      change.color = action.data.color
      change.redirect = action.data.redirect
      change.unauthRedirect = action.data.unauthRedirect
      change.undockRedirect = action.data.undockRedirect
      change.socket = action.data.socket
      change.kioskId = action.data.kioskId
      change.tabletId = action.data.tabletId
      change.socketURL = action.data.socketURL
      change.directMessageTargetDeviceId = action.data.directMessageTargetDeviceId
      change.kioskQueryParams = `?center=${action.data.center}&kioskId=${action.data.kioskId}&app=${action.data.app}&locale=${action.data.locale}`
      change.noDock = action.data.noDock
      break
    }
    case SETUP_DIRECT_MESSAGE_LINK: {
      setSessionStorageItem({ directMessageTargetDeviceId: action.data.directMessageTargetDeviceId })
      change.directMessageTargetDeviceId = action.data.directMessageTargetDeviceId
      break
    }
    case SET_MESSAGE: {
      change.message = action.data.message
      break
    }
    case SET_CONNECTION_STATUS: {
      change.connectionStatus = action.data.connectionStatus
      break
    }
    case SET_CHINESE_STATUS: {
      change.isChinese = action.data.isChinese
      break
    }
    case SET_REDIRECT: {
      change.redirect = action.data.redirect
      break
    }
    default: {
      console.error(`ERROR: Unhandled action type: ${action.type}`) // eslint-disable-line
    }
  }
  return { ...state, ...change }
}

export { kioskInitialState, kioskReducer }
